export const EVENT_TRACK_VIDEO_PROVIDER = "EVENT_TRACK_VIDEO_PROVIDER";
export const EVENT_TRACK_AD_VIEW = "EVENT_TRACK_AD_VIEW";
export const EVENT_TRACK_AD_REPORT = "EVENT_TRACK_AD_REPORT";
export const EVENT_TRACK_AD_VIDEO_VIEW = "EVENT_TRACK_AD_VIDEO_VIEW";
export const EVENT_TRACK_AD_VIDEO_ERROR = "EVENT_TRACK_AD_VIDEO_ERROR";
export const EVENT_MATCH_NATIVE_VIEW = "EVENT_MATCH_NATIVE_VIEW";
export const EVENT_MATCH_NATIVE_CLICK = "EVENT_MATCH_NATIVE_CLICK";
